export const EVALUATION_TEAM = '/evaluationTeam';
export const NON_COMFORMITES_TEMPLATE = '/technicalReviewer/non-conformities-template';